<template>
    <el-card>
        <el-page-header @back="close" content="数据源信息"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form ref="form" :model="form" :rules="rules" :status-icon="true" label-width="100px">
                    <el-form-item label="描述" prop="description">
                        <el-input v-model="form.description" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="名称" prop="name">
                        <el-input v-model="form.name" maxlength="10" show-word-limit style="width: 300px" :disabled="id > 0"></el-input>
                    </el-form-item>
                    <el-form-item label="地址" prop="host">
                        <el-input v-model="form.host"></el-input>
                    </el-form-item>
                    <el-form-item label="端口" prop="port">
                        <el-input-number v-model="form.port"></el-input-number>
                    </el-form-item>
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="form.username"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input v-model="form.password"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </el-card>
</template>

<script>
    export default {
        props: ["id"],
        data() {
            return {
                form: {
                    port: 3306
                },
                rules: {
                    description: [{required: true, message: '请填写数据源描述信息'}],
                    name: [
                        {required: true, message: '请输入数据源名称'},
                        {pattern: /^[a-zA-Z0-9]+$/, message: "只允许字母和数字"}
                    ],
                    host: [{required: true, message: '请填写数据库地址'}],
                    port: [{required: true, message: '请填写端口号'}],
                    username: [{required: true, message: '请填写账号'}],
                    password: [{required: true, message: '请填写密码'}]
                },
            };
        },
        beforeMount() {
            if (this.id > 0) {
                this.$axios.get("/datasource/get/" + this.id).then(response => {
                    this.form = response.data;
                });
            }
        },
        methods: {
            submit() {
                if (this.form.id) {
                    this.$confirm('修改数据源会导致原租户数据不可用，请谨慎操作，是否继续？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$utils.submit(this.$refs.form, "/datasource/edit", this.form, () => {
                            this.$emit("close", true);
                        });
                    })
                } else {
                    this.$utils.submit(this.$refs.form, "/datasource/save", this.form, () => {
                        this.$emit("close", true);
                    });
                }
            },
            close() {
                this.$emit("close", false);
            }
        }
    }
</script>